import React, { useRef, useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { SGBPCategoryCriteriaData } from "./data/SGBPCategoryCriteriaData";
import { SGBPCategoryCriteriaConfig } from "./data/SGBPCategoryCriteriaConfig";
import { useGetAllCategoryCriteriaMappingListMutation } from "../../app/services/Crud/crudApi";
import { useLazyGetAllDropdownForCRUDCategoryQuery } from "../../app/services/Crud/crudApi";
import { setAllDropDownField } from "./Utils/setAllDropDownField";
import { encryptAESID } from "../../utils/Encryption";

const SGBPCategoryList = () => {
  const navigate = useNavigate();
  const molGridRef = useRef();
  const SGBPCategoryCriteriaRef = useRef();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    SearchByCode: null,
    CategoryId: null,
    SubCategoryId: null,
    TypeId: null,
    StatusId: null,
    ChannelId: null,
  });
  const [dataSource, setDataSource] = useState([])
  const [sGBPCategoryCriteriaFormData, setSGBPCategoryCriteriaFormData] = useState(SGBPCategoryCriteriaData);
  const [getAllCategoryCriteriaMappingList, { data: allCategoryCriteriaMappingListData, isLoading: allCategoryCriteriaMappingListLoading }] = useGetAllCategoryCriteriaMappingListMutation();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();

  useEffect(() => {
    if (!allCategoryCriteriaMappingListLoading && allCategoryCriteriaMappingListData) {
      let categoryRecord = allCategoryCriteriaMappingListData.itemList.map((item) => {
        return {
          ...item,
          subCategoryL2Name: item?.subCategoryL2Name == null ? "-" : item.subCategoryL2Name,
          typeL3Name: item?.typeL3Name == null ? "-" : item.typeL3Name,
        }
      })
      setPaginationRequest((prev) => ({ ...prev, totalCount: allCategoryCriteriaMappingListData?.totalCount, }));
      setDataSource(categoryRecord)
    }
  }, [allCategoryCriteriaMappingListLoading, allCategoryCriteriaMappingListData]);

  useEffect(() => {
    getDropdowns();
    getAllCategoryCriteriaMappingList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllCategoryCriteriaMappingList(updatedPaginationRequest);
  };

  const handleSearch = () => {
    if (!SGBPCategoryCriteriaRef.current) {
      return
    }
    const formData = SGBPCategoryCriteriaRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      SearchByCode: formData?.searchbyCode?.label || '',
      CategoryId: formData?.categoryId?.value || formData?.categoryId,
      SubCategoryId: formData?.subCategoryId?.value || formData?.subCategoryId,
      TypeId: formData?.typeId?.value || formData?.typeId,
      StatusId: formData?.statusId?.value || formData?.statusId,
      ChannelId: null,
    };
    setPaginationRequest(updatedPaginationRequest)
    getAllCategoryCriteriaMappingList(updatedPaginationRequest);
  }

  const handleClearClick = () => {
    const updatedFormData = { ...SGBPCategoryCriteriaData };
    updatedFormData.initialState = {
      subCategoryId: null,
      statusId: null,
      typeId: null,
      categoryId: null,
      searchbyCode: null
    };
    setPaginationRequest({
      pageNo: 1,
      pageSize: 20,
      SearchByCode: null,
      CategoryId: null,
      SubCategoryId: null,
      TypeId: null,
      StatusId: null,
      ChannelId: null,
    })
    const request = {
      PageNo: 1,
      PageSize: 20,
      CategoryId: null,
      SubCategoryId: null,
      TypeId: null,
      StatusId: null,
      searchbyCode: null,
      totalCount: 0,
    };
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllCategoryCriteriaMappingList(request);
    setSGBPCategoryCriteriaFormData(updatedFormData);
  };

  const handleAdd = () => {
    navigate('/AddSGBPCategory')
  }

  const handleEditClick = (data) => {
    navigate(`/editSGBPCategory/${encryptAESID(data?.sgbpCategoryCriteriaCertificateMappingId)}`);
  }

  const actionHandler = {
    Edit: handleEditClick,
  };

  return (
    <div className="crud-requirement-list">
      <div className="corporate-member-list">
        <div className="sgbp-category">
          <div className="row status-input pr-0">
            {dropdownData?.length > 0 && (
              <FormCreator ref={SGBPCategoryCriteriaRef} {...sGBPCategoryCriteriaFormData} />
            )}
          </div>
          <div className="sgbp-category-filter">
            <Buttons
              buttonText="Search"
              buttonTypeClassName="search-btn"
              onClick={handleSearch}
            />
            <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn btn-secondary mb-2"
              onClick={handleClearClick}
            />
          </div>
          <div className="add-btn-sec mt-4 pr-0">
            <Buttons
              buttonText="+ Add New"
              buttonTypeClassName="add-btn"
              onClick={handleAdd}
            />
          </div>
        </div>

        <div className="member-list">
          <MolGrid
            ref={molGridRef}
            configuration={SGBPCategoryCriteriaConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default SGBPCategoryList;
